<div class="flex-column gap-flex-24 pad-24" *ngIf="customersFacadeService.dashboardLoading$ | async" role="status"
  aria-busy="true" aria-label="Loading dashboard">
  <sk-header [crumbs]="0"></sk-header>
  <sk-card-grid [count]="4"></sk-card-grid>
  <sk-card-grid [count]="1"></sk-card-grid>
</div>
<div class="gap-grid-24 pad-24 dashboard" *ngIf="!(customersFacadeService.dashboardLoading$ | async)">
  <div class="flex-column">
    <span class="navigation-button brand-heading-text">Dashboard</span>
    <span class="brand-heading-subtext">System overview and health metrics</span>
  </div>
  <!-- Summary cards -->
  <ng-container *ngIf="customersFacadeService.customersSummaryData$ | async as summaryDataList">
    <section class="metrics-row gap-grid-24">
      <app-card-modal *ngFor="let summaryData of summaryDataList" [title]="summaryData.title"
        [subtitle]="summaryData.subtitle" [value]="summaryData.value" [trend]="summaryData.trend"
        [src]="summaryData.icon" [modalTemplate]="summaryData.modalTemplate" [data]="summaryData.customerData"
        [isDisabled]="!summaryData.customerData.length">
      </app-card-modal>
    </section>
  </ng-container>

  <!-- Status bars -->
  <section class="gap-grid-24 status-row" *ngIf="customersFacadeService.dashboardStatusData$ | async">
    <mat-card class="gap-flex-12 status-card-container" appearance="outlined"
      *ngFor="let statusData of customersFacadeService.dashboardStatusData$ | async">
      <mat-card-header>
        <div class="text-muted-md">{{ statusData.title }}</div>
      </mat-card-header>
      <mat-card-content class="flex-column">
        <div *ngFor="let barData of statusData.data" class="flex-column gap-flex-8">
          <div class="flex-row-justify-between status-label-container">
            <span class="text-sm">{{ barData.label }}</span>
            <div class="flex-row gap-flex-8">
              <mat-chip class="status-count-chip status-count-chip--clickable" appActionable
                [matTooltip]="'View venues on ' + barData.label"
                (click)="openEditionVenues(statusData.title, barData)">{{ barData.value }}</mat-chip>
              <span class="text-muted-xs">{{ barData.percent }} %</span>
            </div>
          </div>
          <mat-progress-bar color="primary" mode="determinate" [value]="barData.percent"></mat-progress-bar>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
</div>
<ng-template #editionVenues>
  <div class="gap-flex-24 pad-24 flex-column">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeEditionVenues()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ editionTitle }}</span>
    </div>

    <mat-card appearance="outlined" class="pad-24 ">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ editionCustomers.length | number }}</span>
        <span class="text-muted-sm">{{ editionLabel }}</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="pad-16 header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="editionCustomers" [autoGenerate]="false" [height]="'Auto'"
        [emptyGridMessage]="'No data available'" (rowClick)="openVenueDetails($event)">
        <igx-column *ngFor="let col of modalSiteColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'">
          <ng-template igxCell let-cell="cell">
            <span [class.brand-text-sm]="col.type === 'label'">{{ cell.value || '-' }}</span>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>